import Vue from 'vue'
import {dd,store,app} from 'systems/imports'

import BaseProcessor from 'processor/BaseProcessor'
import API from 'api/Order'

/**
 * 運営サイト情報
 */
class Order extends BaseProcessor{
  static getClassName(){ return 'Order' }

  static findOrder(input){
    return new Promise(function(resolve, reject) {
      API.findOrder(input)
        .then((res)=>{
          return resolve({status:"ok",data:{order:res.order} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static getOrders(input){
    return new Promise(function(resolve, reject) {
      API.getOrders(input)
        .then((res)=>{
          return resolve({status:"ok",data:{orders:res.orders} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static updateQrderQuestionnaireAnswer(input){

    return new Promise(function(resolve, reject) {
      API.updateQrderQuestionnaireAnswer(input)
        .then((res)=>{
          return resolve({status:"ok",data:{order:res.order} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static updateOrdererQuestionnaireAnswer(input){

    return new Promise(function(resolve, reject) {
      API.updateOrdererQuestionnaireAnswer(input)
        .then((res)=>{
          return resolve({status:"ok",data:{order:res.order} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

}

export default Order



// WEBPACK FOOTER //
// ./src/processor/Order.js